import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import classes from "./SearchBar.module.css";
import { Col, Container, Row } from "react-bootstrap";
import useClickOutsideHook from "../../CustomHooks/useClickOutsideHook";
import { Button } from "../Button/Button";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import { DoubleCalander } from "../DoubleCalander/DoubleCalander";
import { useEffect } from "react";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";

export const SearchBar = ({
  locationArray,
  searchArray,
  onSubmitSearch,
  ShowShadow,
}) => {
  const [search, setSearch] = useState("");
  const [searchFocus, setSearchFoucs] = useState(false);
  const [location, setLocation] = useState("");
  const [locationFocus, setLocationFoucs] = useState(false);
  const [date, setDate] = useState([null, null]);
  const [dateFocus, setDateFoucs] = useState(false);

  const [locationRef] = useClickOutsideHook(() => setLocationFoucs(false));
  const [searchRef] = useClickOutsideHook(() => setSearchFoucs(false));
  const [dateRef] = useClickOutsideHook(() => setDateFoucs(false));

  useEffect(() => {
    if (date[0] !== null && date[1] !== null) {
      locationRef.current.focus();
      setTimeout(() => {
        setSearchFoucs(false);
        setDateFoucs(false);
        setLocationFoucs(true);
      }, 50);
    }
  }, [date]);

  return (
    <>
      <style jsx>{`
        .${classes.focus} {
          border-color: ${Colors.neutralShadesOfNero};
        }
        .${classes.SearchBar} {
          ${ShowShadow == false && "box-shadow: unset;"}
        }
      `}</style>
      <Container
        className={` p-0 ${[classes.SearchBar].join(" ")}`}
        style={{ backgroundColor: Colors.white }}
      >
        <Row className={`${[classes.customRow].join(" ")}`}>
          <Col
            md={4}
            className={`${[
              classes.innerContainer,
              classes.separatorContainer,
              searchFocus && classes.focus,
            ].join(" ")}`}
            ref={searchRef}
          >
            <Row>
              <Col
                md={12}
                onClick={() => {
                  setSearchFoucs(true);
                  setLocationFoucs(false);
                  setDateFoucs(false);
                }}
                className={[classes.headingContainer].join(" ")}
              >
                <span
                  htmlFor={`inputSearch`}
                  className={[classes.title].join(" ")}
                  style={{
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Search
                </span>
              </Col>
              <Col
                md={12}
                onClick={() => {
                  setSearchFoucs(true);
                  setLocationFoucs(false);
                  setDateFoucs(false);
                }}
              >
                <input
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                  autoFocus={searchFocus}
                  placeholder={"Sport type, technique, etc..."}
                  autocomplete="off"
                  type={"text"}
                  id={`inputSearch`}
                  className={[classes.input].join(" ")}
                  style={{ color: Colors.neutralShadesOfDimGray, ...Fonts.p1 }}
                />

                <CloseIcon
                  color={"black"}
                  style={{
                    position: "absolute",
                    right: "3%",
                    top: "34%",
                    opacity: searchFocus && search.length > 0 ? 1 : 0,
                  }}
                  onClick={() => {
                    setSearch("");
                  }}
                />
              </Col>
              {searchFocus && (
                <Col md={12}>
                  <div className={[classes.searchOverlayContainer].join(" ")}>
                    {searchArray.map((item, index) => (
                      <span
                        onClick={() => {
                          dateRef.current.focus();
                          setSearch(item);
                          setTimeout(() => {
                            setSearchFoucs(false);
                            setLocationFoucs(false);
                            setDateFoucs(true);
                          }, 50);
                        }}
                      >
                        {item}
                      </span>
                    ))}
                    <span
                      className={[classes.alertColor].join(" ")}
                      style={{ color: Colors.mainShadeOfRed }}
                      onClick={() => {
                        console.log("123");
                      }}
                    >
                      All sports will be available very soon.
                    </span>
                  </div>
                </Col>
              )}
            </Row>
          </Col>

          <Col
            md={3}
            className={`${[
              classes.innerContainer,
              classes.separatorContainer,
              dateFocus && classes.focus,
            ].join(" ")}`}
            onClick={() => {
              setDateFoucs(true);
              setLocationFoucs(false);
              setSearchFoucs(false);
            }}
            ref={dateRef}
          >
            <Row>
              <Col md={12} className={[classes.headingContainer].join(" ")}>
                <span
                  className={[classes.title].join(" ")}
                  style={{
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Date
                </span>
              </Col>
              <Col md={12}>
                {date[0] == null ? (
                  <span
                    className={[classes.placeholderText].join(" ")}
                    style={{
                      color: Colors.neutralShadesOfDimGray,
                      ...Fonts.p1,
                    }}
                  >
                    Add Date
                  </span>
                ) : (
                  <span>
                    {date[0] !== null && moment(date[0]).format("DD MMM")} -{" "}
                    {date[1] !== null && moment(date[1]).format("DD MMM")}{" "}
                  </span>
                )}
                <CloseIcon
                  color={"black"}
                  style={{
                    position: "absolute",
                    right: "3%",
                    top: "34%",
                    opacity:
                      dateFocus && (date[0] !== null || date[1] !== null)
                        ? 1
                        : 0,
                  }}
                  onClick={() => {
                    setDate([null, null]);
                  }}
                />
              </Col>
              {dateFocus && (
                <Col md={12}>
                  <div
                    className={[classes.dateOverlayContainer].join(" ")}
                    style={{ backgroundColor: Colors.white }}
                  >
                    <DoubleCalander setValue={setDate} value={date} />
                  </div>
                </Col>
              )}
            </Row>
          </Col>
          <Col
            md={3}
            className={`${[
              classes.innerContainer,
              locationFocus && classes.focus,
            ].join(" ")}`}
            ref={locationRef}
          >
            <Row>
              <Col
                md={12}
                onClick={() => {
                  setLocationFoucs(true);
                  setSearchFoucs(false);
                  setDateFoucs(false);
                }}
                className={[classes.headingContainer].join(" ")}
              >
                <span
                  htmlFor={`inputLocation`}
                  className={[classes.title].join(" ")}
                  style={{
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  location
                </span>
              </Col>
              <Col
                md={12}
                onClick={() => {
                  setLocationFoucs(true);
                  setSearchFoucs(false);
                  setDateFoucs(false);
                }}
              >
                <input
                  value={location}
                  onChange={(e) => {
                    setLocation(e.target.value);
                  }}
                  autoFocus={locationFocus}
                  placeholder={"Add Location"}
                  autocomplete="off"
                  type={"text"}
                  id={`inputLocation`}
                  className={[classes.input].join(" ")}
                  style={{ color: Colors.neutralShadesOfDimGray, ...Fonts.p1 }}
                />
                <CloseIcon
                  color={"black"}
                  style={{
                    position: "absolute",
                    right: "3%",
                    top: "34%",
                    opacity: locationFocus && location.length > 0 ? 1 : 0,
                  }}
                  onClick={() => {
                    setLocation("");
                  }}
                />
              </Col>
              {locationFocus && (
                <Col md={12}>
                  <div
                    className={[classes.searchOverlayContainer].join(" ")}
                    style={{ backgroundColor: Colors.white }}
                  >
                    {locationArray.map((item, index) => (
                      <span
                        onClick={() => {
                          locationRef.current.focus();
                          setLocation(item);
                          setTimeout(() => {
                            setSearchFoucs(false);
                            setDateFoucs(false);
                            setLocationFoucs(false);
                          }, 50);
                        }}
                      >
                        {item}
                      </span>
                    ))}
                  </div>
                </Col>
              )}
            </Row>
          </Col>
          <Col
            md={2}
            className={`${[classes.innerContainer].join(" ")}`}
            style={{
              padding: "16px",
            }}
          >
            <Button
              primary={true}
              size={"Large"}
              label={"Search"}
              disabled={false}
              onClick={() => {
                onSubmitSearch({ search, date, location });
              }}
              customStyle={{
                ...Fonts.b1,
              }}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

SearchBar.propTypes = {
  searchArray: PropTypes.array,
  locationArray: PropTypes.array,
  onSubmitSearch: PropTypes.func,
  ShowShadow: PropTypes.bool,
};

SearchBar.defaultProps = {
  searchArray: [
    "Tennis",
    "Soccer",
    "Football",
    "Golf",
    "Skating",
    "Baseball",
    "Basketball",
  ],
  locationArray: ["San Diego"],
  ShowShadow: true,
};
